export const routes = {
  HOME: '/',
  VIP: '/vip',
  PROMOTIONS: '/promotions',
  JACKPOTS: '/jackpots',
  CASINO: '/casino',
  REGISTER: '/register',
  SPORTS: '/deportes',
  TOURNAMENTS: '/torneos',
  CHALLENGES: '/desafios',
  INFO: '/info',
  DASHBOARD: '/dashboard',
  DEPOSIT: '/deposito',
  LOGIN: '/login',
  REFERALS: '/referidos',
  NOTIFICATIONS: '/notificaciones',
  MENU: '/menu',
  STREAMS: '/streams',
  RAFFLES: '/sorteos',
  MARKETPLACE: '/tienda',
};
